import { ActionAPI, FormAPI } from '@philips-internal/oswald-ui-components';
import { ButtonTheme } from '@philips-internal/oswald-ui-constants';
import { BrokerService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import TASK_ITEM_STATUS from '../constants/task-item-status';
import TASK_STATUS from '../constants/task-status';
import TaskItem from '../interfaces/task-item';

interface BaseInitialStatusProps {
  onBlocked?: () => void;
  onCompleted?: () => void;
  onPending?: () => void;
  taskItem: TaskItem;
}
interface InitialActionStatusProps extends BaseInitialStatusProps {
  checkActionAPI: ActionAPI;
}

interface InitialFormStatusProps extends BaseInitialStatusProps {
  formApi: FormAPI;
}

export class TasksUtils {

  static setActionChecked(checkActionAPI: ActionAPI, identifier: string): void {
    checkActionAPI.setText(MessageService.translate('patient.checked'));
    checkActionAPI.setButtonTheme(ButtonTheme.ACCENT);
    BrokerService.publishToTopic(identifier, true);
  }

  /**
   * Disables editing the form if the task has a blocked status.
   * @param props Properties used by the method
   */
  static setInitialFormStatus(props: InitialFormStatusProps): void {
    const { taskItem, formApi, onPending, onCompleted, onBlocked } = props;
    if (!taskItem) {
      return;
    }

    const ieStatusTarefa = taskItem?.ieStatusTarefa;
    switch (true) {
      case taskItem.statusTaskCalculated === TASK_ITEM_STATUS.BLOCKED:
        TasksUtils.disabledForm(formApi);
        TasksUtils.executeCallback(onBlocked);
        break;
      case ieStatusTarefa === TASK_STATUS.PENDING:
        TasksUtils.executeCallback(onPending);
        break;
      case ieStatusTarefa === TASK_STATUS.COMPLETED:
        TasksUtils.disabledForm(formApi);
        TasksUtils.executeCallback(onCompleted);
        break;
      default:
        break;
    }
  }

  /**
   * Disables the Action if the task has a blocked status.
   * @param props Properties used by the method
   */
  static setInitialActionStatus(props: InitialActionStatusProps): void {
    const { taskItem, checkActionAPI, onPending, onCompleted, onBlocked } = props;
    if (!taskItem) {
      return;
    }

    const ieStatusTarefa = taskItem?.ieStatusTarefa;
    switch (true) {
      case taskItem.statusTaskCalculated === TASK_ITEM_STATUS.BLOCKED:
        checkActionAPI.setEnabled(false);
        TasksUtils.executeCallback(onBlocked);
        break;
      case ieStatusTarefa === TASK_STATUS.PENDING:
        TasksUtils.executeCallback(onPending);
        break;
      case ieStatusTarefa === TASK_STATUS.COMPLETED:
        checkActionAPI.setText(MessageService.translate('patient.checked'));
        checkActionAPI.setButtonTheme(ButtonTheme.ACCENT);
        TasksUtils.executeCallback(onCompleted);
        break;
      default:
        break;
    }
  }

  private static disabledForm(formApi: FormAPI): void {
    formApi.setEditing(false);
    formApi.setLocked(true);
  }

  private static executeCallback(callback: (() => void) | undefined): void {
    if (isFunction(callback)) {
      callback();
    }
  }
}